module.exports = __webpack_public_path__ + "media/images/client-faganwhalley-87f6cdb0c4f4988feb87a5d99e2a192e.svg";